// Unordered chats retain their incoming date order. Saved IDs that are not
// loaded yet never create rows, but remain available when history is paged in.
export function orderSidebarChats(chats, order = []) {
  const ranks = new Map(order.map((id, index) => [String(id), index]));
  return [...chats].sort((a, b) => {
    if (!!a.isPinned !== !!b.isPinned) return a.isPinned ? -1 : 1;
    return (ranks.get(String(a.id)) ?? Infinity) - (ranks.get(String(b.id)) ?? Infinity);
  });
}

export function moveSidebarChat(chats, sourceId, targetId, after) {
  const source = chats.find(chat => String(chat.id) === sourceId);
  const target = chats.find(chat => String(chat.id) === targetId);
  if (!source || !target || source === target || !!source.isPinned !== !!target.isPinned) return null;
  const next = chats.filter(chat => chat !== source);
  next.splice(next.indexOf(target) + (after ? 1 : 0), 0, source);
  return next.some((chat, index) => chat !== chats[index]) ? next.map(chat => String(chat.id)) : null;
}

// Replace only known slots so reordering a partially loaded list preserves
// the relative positions of older chats saved during an earlier session.
export function mergeSidebarChatOrder(previous = [], ids = []) {
  const unique = [...new Set(ids.map(String))];
  const present = new Set(unique);
  let index = 0;
  const merged = [...new Set(previous.map(String))].map(id => present.has(id) ? unique[index++] : id);
  return [...merged, ...unique.slice(index)];
}
